'use client'
import {
  LINK_QUERY
} from "./chunk-Y5YNZ765.mjs";
import {
  IMAGE_QUERY
} from "./chunk-AFUSNP5S.mjs";

// src/api/queries/header.ts
var HEADER_QUERY = `
topNavigationCollection {
items {
    ${LINK_QUERY}
}
}
topSubNavigationCollection {
items {
    ${LINK_QUERY}
}
}
bottomNavigationCollection {
items {
    ${LINK_QUERY}
}
}
zonesCollection {
items {
    title
    slug
    zoneLogo {
    ${IMAGE_QUERY}
    }
    sponsorLogo {
    ${IMAGE_QUERY}
    }
}
}
menuLinksCollection(limit: 5) {
items {
    id
    title
    linksCollection(limit: 10) {
    items {
        ${LINK_QUERY}
    }
    }
}
}
userMenu
searchBar
`;

export {
  HEADER_QUERY
};
//# sourceMappingURL=chunk-WQ643R7Q.mjs.map